export { RecentlyViewedCarousel } from './recently-viewed-carousel';
